export default `
# 1. HTTP 方式签名

## 签名方式（sha1的方式）
1. 将请求体中的参数除去 sign 字段外按照字典序排序，按照 \`key1=value1&key2=value2\` 的格式拼接成字符串
2. 将拼接后的字符串进行 base64 编码
3. 将 base64 编码后的字符串前拼接上 \`appSecret:\`
4. 将拼接后的字符串进行 sha1 加密得到 sign 值

## 签名示例
\`com.souche.shield.service#getUserById（根据用户 ID 获取用户信息）\`

API 参数文档

| 字段 | 类型   | 是否必须 | 含义    | 备注 |
| ---- | ------ | -------- | ------- | ---- |
| id   | String | ✔️        | 用户 ID |      |

请求数据

\`\`\`json
{
    "api": "com.souche.shield.service#getUserById",
    "appKey": "ad33d1190ff8383b5650097c0b6403868a82bd4c",
    "timestamp": 1528420183,
    "data": "{\\"id\\":\\"xv1fg4h\\"}",
    "sign": "9b94171630348afdb950b8c26edeec608e0c1f78"
}
\`\`\`

签名流程

1. 请求体参数排序并拼接字符串
  \`\`\`
api=com.souche.shield.service#getUserById&appKey=ad33d1190ff8383b5650097c0b6403868a82bd4c&data={"id":"xv1fg4h"}&timestamp=1528420183
  \`\`\`
2. 将拼接后的字符串进行 base64 编码
    \`\`\`
 YXBpPWNvbS5zb3VjaGUuc2hpZWxkLnNlcnZpY2UjZ2V0VXNlckJ5SWQmYXBwS2V5PWFkMzNkMTE5MGZmODM4M2I1NjUwMDk3YzBiNjQwMzg2OGE4MmJkNGMmZGF0YT17ImlkIjoieHYxZmc0aCJ9JnRpbWVzdGFtcD0xNTI4NDIwMTgz
    \`\`\`

3. 将 base64 编码后的字符串前拼接上 \`appSecret:\`
  \`\`\`
   569f4f8050a4bfc87ebfaf1e0b4d71aae58f3958:YXBpPWNvbS5zb3VjaGUuc2hpZWxkLnNlcnZpY2UjZ2V0VXNlckJ5SWQmYXBwS2V5PWFkMzNkMTE5MGZmODM4M2I1NjUwMDk3YzBiNjQwMzg2OGE4MmJkNGMmZGF0YT17ImlkIjoieHYxZmc0aCJ9JnRpbWVzdGFtcD0xNTI4NDIwMTgz
  \`\`\`

4. 将拼接后的字符串进行 sha1 加密的到 sign 值

  \`\`\`
  9b94171630348afdb950b8c26edeec608e0c1f78
  \`\`\`
## 签名方式（sha256的方式）
1. 将请求体中的参数除去 sign 字段外按照字典序排序，按照 \`key1=value1&key2=value2\` 的格式拼接成字符串
2. 将拼接后的字符串进行 base64 编码
3. 将 base64 编码后的字符串前拼接上 \`appSecret:\`
4. 将拼接后的字符串进行 sha256 加密得到 sign 值
5. 请求头中需要添加 x-souche-sign-type:sha-256



#  2. SDK 方式签名

- 对请求开放平台的签名封装，合作公司直接使用业务参数调用 API 。
- 对验签做了封装，合作公司直接使用验签工具对开放平台的回调参数做验签。

##  SDK 下载地址（sha-1）

  -  [souche-sdk-java*.jar](http://souche.oss-cn-hangzhou.aliyuncs.com/sdk/souche-sdk-java.jar)
##  请求开放平台调用方式

\`\`\`java
String serverUrl = "http://openapi.proxy.dasouche.com/v3";
String appKey = "d2f0a651df7910cf6393ab8448b33744";
String appSecret = "c66ea9f4c603cb5fcd45a4ebf90c33e0";

// 实例化 SDK 客户端
SoucheClient soucheClient = new SoucheClient(serverUrl, appKey, appSecret);

// 实例化请求类
SoucheRequest request = new SoucheRequest();

Map<String, Object> dataMap = new HashMap<String, Object>();
dataMap.put("domainNo", "gh");
dataMap.put("groupNo", "gh");
dataMap.put("shopNo", "gh00000118");

// 设置请求参数 api {String}
request.setApi("com.souche.worknum.api.exp.WorkNumInfoExp#getCountShopWorkNum");
// 设置请求参数 data {Map<String, Object>}
request.setData(dataMap);

try {
  // 发送请求
  SoucheResponse response = soucheClient.execute(request);
  if (response.isSuccess()) {
    // 请求成功
    String data = response.getData();
    System.out.println(data);
  }
} catch (SoucheApiException e) {
  // 业务错误查看 errCode 和 errMessage 内容
  int errCode = e.getErrCode();
  String errMessage = e.getErrMessage();
  System.out.println(errCode + ": " + errMessage);

  // 通信错误查看 message 内容
  String errorMessage = e.getMessage();
  System.out.println(errorMessage);
}
\`\`\`
##  开放平台回调消息参数验签调用方式

\`\`\`java
String reqString = "{\\"data\\":\\"{\\\\\\"domainNo\\\\\\":\\\\\\"gh\\\\\\",\\\\\\"groupNo\\\\\\":\\\\\\"gh\\\\\\",\\\\\\"shopNo\\\\\\":\\\\\\"gh00000118\\\\\\"}\\",\\"sign\\":\\"5f439cb3d8c941097933c37af61136e5bf4d5a49\\",\\"appKey\\":\\"d2f0a651df7910cf6393ab8448b33744\\",\\"api\\":\\"com.souche.worknum.api.exp.WorkNumInfoExp#getCountShopWorkNum\\",\\"timestamp\\":\\"1551946529\\"}";
String appSecret = "c66ea9f4c603cb5fcd45a4ebf90c33e0";

// 验签
boolean result = SoucheSignature.check(reqString, appSecret);
\`\`\`

##  SDK 下载地址（sha-256）
- [souche-sdk-java-2.0.0-SNAPSHOT.jar](https://souche.oss-cn-hangzhou.aliyuncs.com/sdk/souche-sdk-java-2.0.0-SNAPSHOT.jar)
`


